<template>
    <div class="questionTray">
        <div ref="questions" class="questions">
            <ul class="questionList">
                <questionbox v-for="(question, index) in filteredQuestions" :key="index" :question="question" :person="getPerson(index)" :peopleMap="peopleMap" :user="user" v-on:openPersonCard="openPersonCard($event)" v-on:showChildAtPosition="showChildAtPosition"></questionbox>
            </ul>
            <div v-if="isEmpty" class="background-message"><div>{{$t('str.NoQuestionsAsked')}}</div></div>
        </div>
        <div class="questionSubmit">
            <textarea v-model="questionText" v-on:keyup.enter="submitQuestion" maxlength="500" class="questionText" :placeholder="$t('str.EnterYourQuestionHere')"></textarea>
            <label class="chars"> {{questionText.length}} / 500 </label>
            <img v-on:click="submitQuestion" class="submitButton" src="../../assets/icons/enter_white.svg">
        </div>
        <div class="question-text-arrow"></div>
        <personcard v-if="this.viewPerson" :attendee="this.viewPerson" :user="user" v-on:cardClosed="personCardClosed"></personcard>
    </div>
</template>

<script>

import QuestionBox from '@/components/question/QuestionBox';
import PersonCard from '@/components/PersonCard';
import {EventBus} from '../../router/index';
import Spinner from '@/components/Spinner';

export default {
    components: {
        questionbox: QuestionBox,
        personcard: PersonCard,
        spinner: Spinner
    },

    props: {
        peopleMap: {},
        questions: {},
        user: {}
    },

    data () {
        return {
            questionText: '',
            viewPerson: undefined,
            lastQuestionsCount: 0
        };
    },

    computed: {
        isEmpty() {
            return this.questions !== undefined && !this.questions.length;
        },

        filteredQuestions() {
            if (!this.questions) {
                return [];
            }

            let filtered = [];

            for(let questionContainer of this.questions) {
                if (questionContainer.question && questionContainer.question.length > 0) {
                    filtered.push(questionContainer);
                }
            }

            return filtered;
        }
    },

    watch: {
        questions() {
            if (this.lastQuestionsCount !== this.questions.length) {
                this.showLastQuestions();
            }
        }
    },


    mounted() {
        this.showLastQuestions();
    },

    methods: {
        submitQuestion() {
            if (this.questionText === '') {
                return;
            }

            EventBus.$emit('postQuestion', this.questionText.trim());
            this.questionText = '';
        },

        getPerson(index) {
            return this.peopleMap.get ? this.peopleMap.get(this.questions[index].orignatorId) : {};
        },

        openPersonCard(person) {
            this.viewPerson = person;
        },

        personCardClosed() {
            this.viewPerson = undefined;
        },

        showChildAtPosition(offsetHeight) {
            if (offsetHeight !== undefined) {
                this.$refs.questions.scrollTop = offsetHeight;
            }
        },

        showLastQuestions() {
            if (this.$refs.questions === undefined || !this.questions) {
                return;
            }

            this.lastQuestionsCount = this.questions.length;

            setTimeout(() => {
                this.$refs.questions.scrollTop = this.$refs.questions.scrollHeight;
            }, 100);
        }
    }
};

</script>

<style lang="scss">

$placeholder-color: rgba(255, 255, 255, 0.7);

.questionTray {
    width: 100%;
    background-color: #000;
    overflow: hidden;
    height: calc(100% - 65px);

    .questions {
        position: fixed;
        top: 65px;
        bottom: 130px;
        overflow-y: scroll;
        overflow-x: hidden;
        -webkit-overflow-scrolling: touch;
        max-height: 100%;
        width: 100%;

        .questionList {
            list-style-type: none;
            padding-left: 10px;
            margin: 0;
        }

        .background-message {
            width: 100%;
            height: 100%;
            display: table;
            font-size: 0.9em;
            font-family: "Poppins", "Helvetica Neue", Helvetica, Arial, sans-serif;
            font-weight: normal;

            & > div {
                display: table-cell;
                text-align: center;
                vertical-align: middle;
            }
        }
    }

    .questionSubmit {
        position: fixed;    
        bottom: 70px;
        width: calc(100% - 20px);
        margin-left: 10px;
        margin-right: auto;
        height: 55px;
        background-color: #d4451d;
        overflow: hidden;
        z-index: 1000;
        border-radius: 0 0 10px 10px;

        .questionText {
            height: 45px;
            width: calc(100% - 60px);
            color: #fff;
            background-color: #d4451d;
            font-family: 'Poppins', sans-serif;
            font-size: 1em;
            line-height: 1.2em;
            padding: 10px 0 0 10px;
            outline: none;
            border: none;
            resize: none;
            overflow: auto;
        }

        .submitButton {
            width: 20px;
            height: 20px;
            line-height: 20px;
            position: absolute;
            bottom: 22px;
            right: 14px;
            z-index: 1;
            cursor: pointer;
            display: inline-block;
            overflow: hidden;
            user-select: none;
        }

        .chars {
            position: fixed;
            right: 16px;
            bottom: 72px;
            color: rgba(255, 255, 255, 0.7);
            font-size: 12px;
            font-family: 'Poppins', sans-serif;
        }
    }

    .question-text-arrow {
        position: fixed;
        display: block;
        border: solid transparent;
        border-right-color: #d4451d;
        content: '';
        height: 0;
        width: 0;
        left: calc(30% - 15px);
        bottom: 42px;
        border-width: 15px;
        transform: rotate(-90deg);
    }
}

::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-track {
  border-radius: 0;
  box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.0);
}

::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.0);
  border-radius: 0;
}

::-webkit-scrollbar-thumb:window-inactive {
  background: rgba(0, 0, 0, 0.0);
}

.questionText::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: $placeholder-color;
    opacity: 1;
}

.questionText::-webkit-placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: $placeholder-color;
}

.questionText:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: $placeholder-color;
}

.questionText::-ms-input-placeholder { /* Microsoft Edge */
    color: $placeholder-color;
}
</style>


// WEBPACK FOOTER //
// QuestionTray.vue?36c1039f